// Inactivity watchdog. The corpus imposes a 30 minute idle timeout on the advisor
// workstation: wealth data stays on screen otherwise. The timer is reset by any real user
// activity and, importantly, also when the tab regains focus after being hidden, because a
// machine left unlocked is exactly the case this protects against.

/** Events that count as activity. Passive listeners: they never block scrolling. */
const EVENEMENTS: readonly string[] = [
  'pointerdown',
  'keydown',
  'wheel',
  'touchstart',
  'visibilitychange',
];

/**
 * Start watching. Calls `surExpiration` once, after `delaiMs` without activity.
 * @returns a function that stops the watch and releases every listener.
 */
export function demarrerVeilleInactivite(delaiMs: number, surExpiration: () => void): () => void {
  let minuteur: ReturnType<typeof setTimeout> | null = null;
  let arrete = false;

  function declencher(): void {
    if (arrete) {
      return;
    }
    arrete = true;
    retirer();
    surExpiration();
  }

  function relancer(): void {
    if (arrete) {
      return;
    }
    if (minuteur !== null) {
      clearTimeout(minuteur);
    }
    minuteur = setTimeout(declencher, delaiMs);
  }

  function surEvenement(): void {
    // A tab becoming hidden is not activity; becoming visible again is.
    if (document.visibilityState === 'hidden') {
      return;
    }
    relancer();
  }

  function retirer(): void {
    if (minuteur !== null) {
      clearTimeout(minuteur);
      minuteur = null;
    }
    for (const nom of EVENEMENTS) {
      document.removeEventListener(nom, surEvenement);
    }
  }

  for (const nom of EVENEMENTS) {
    document.addEventListener(nom, surEvenement, { passive: true });
  }
  relancer();

  return () => {
    arrete = true;
    retirer();
  };
}
